import { Logger as clientLogger } from 'beaver-logger'
import { HOME_PATH } from '../constants'

export default clientLogger({
  url: `${HOME_PATH}/log`,
  // Log level to display in the browser console
  logLevel: 'debug',
})
